import { Box, Button } from "@chakra-ui/react";
import React from "react";

const CTAButtons = ({
  loading,
  onBackClick,
  submitText,
}: {
  loading: boolean;
  onBackClick: any;
  submitText: string;
}) => {
  return (
    <Box
      display={"flex"}
      justifyContent={onBackClick ? "space-between" : "flex-end"}
      flexDirection={["column", "row"]}
      mt="2rem !important"
    >
      {onBackClick && (
        <Button
          width={["100%", "fit-content"]}
          alignSelf={["center", "flex-start"]}
          loadingText="Saving"
          type="button"
          size="lg"
          onClick={onBackClick}
          order={["3", "0"]}
          marginRight={["0", "1.25rem"]}
          mt={["1rem", "0"]}
        >
          Back
        </Button>
      )}
      <Button
        width={["100%", "100%", "49%"]}
        isLoading={loading}
        loadingText="Saving"
        colorScheme="blue"
        type="submit"
        size="lg"
      >
        {submitText}
      </Button>
    </Box>
  );
};

export default CTAButtons;
